<template>
  <div>
    <div>
      <div class="card mt-3 bg-statusWarning">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col">
              <span class="mb-0 pb-0" data-test-hook="expired-dealer-subscription-header">
                <i class="far fa-triangle-exclamation pr-1" data-test-hook="titleIcon" />
                <span style="font-size:1rem; font-weight: bold;" data-test-hook="account-needs-attention-txt">{{
                  $t('xYourAccountNeedsAttentionHeader')
                }}</span>
              </span>
            </div>
          </div>
          <div class="row mb-2 ml-2">
            <div class="col">
              <span data-test-hook="expired-dealer-subscription-banner-body-text">
                {{
                  $t('xExpiredDealerManagedPlanBodyText', {
                    apparatusName: expiredDealerManagedApparatus.name
                  })
                }}
              </span>
            </div>
          </div>
          <div class="row mb-1 ml-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-contact-support"
                @click="navigateToContactSupportPage()"
                data-test-hook="openSupportPageBtn"
              >
                {{ $t('xContactSupport') }}
              </button>

              <button
                type="button"
                class="btn btn-warning btn-contact-dealer ml-2"
                @click="navigateToContactYourDealer()"
                data-test-hook="openPreferredDealerPageBtn"
              >
                {{ $t('xRemoteMonitoringExpiredBodyDealerManagedContactDealer') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Dealer Managed Subscription Modal-->
    <div
      v-if="expiredDealerManagedApparatus && expiredDealerManagedApparatus.apparatusId"
      :id="'dealer-managed-sub-expired' + expiredDealerManagedApparatus.apparatusId"
      role="dialog"
      class="modal fade show"
    >
      <div class="modal-dialog modal-dialog-centered">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="far fa-exclamation-triangle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button type="button" class="btn btn-icon-button--gray btn-icon-button" @click="closeDealerModal()">
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                {{ $t('xYourDealerManagedSubscriptionHasExpiredContactDealer') }}
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <strong>
                  {{ $t('xDealerInformation') }}
                </strong>
              </div>
            </div>
            <div class="col pt-1">
              <div class="row pb-1">
                {{ expiredDealerManagedApparatus.preferredDealerName }}
              </div>
              <div class="row">
                {{ expiredDealerManagedApparatus.preferredDealerPhone }}
              </div>
              <div class="row">
                {{ expiredDealerManagedApparatus.preferredDealerEmail }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <button type="button" @click="navigateToContactSupportPage()" class="btn btn-primary">
              {{ $t('xContactSupportUpgrade') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>
    <!--Modal-->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'
import ModalFooter from '@/modules/modals/components/ModalFooter.vue'

/**
 * The ExpiredDealerManagedBanner shows on the SubscriptionSettings details page when there is an apparatus that is on an expired dealer managed plan.
 */
export default {
  name: 'ExpiredDealerManagedBanner',
  components: {
    ModalFooter
  },
  props: ['expiredDealerManagedApparatus'],
  computed: {
    ...mapState({
      accountProfile: state => state.account.accountProfile
    })
  },
  methods: {
    navigateToContactSupportPage() {
      this.$appInsights.trackEvent({
        name: 'click-to-support-page-with-pending-cancel-subscription', // TODO change
        properties: {}
      })
      this.$router.push({
        path: `/support`
      })
    },
    navigateToContactYourDealer() {
      if (this.expiredDealerManagedApparatus.type === Constants.HsbApparatusType) {
        this.$appInsights.trackEvent({
          name: 'click-contact-your-dealer-expired-dm-banner-plan-details',
          properties: { apparatusId: this.expiredDealerManagedApparatus.apparatusId }
        })
        this.$router.push({
          path: `/details/` + this.expiredDealerManagedApparatus.apparatusId + `/preferredDealer`
        })
      } else {
        this.$appInsights.trackEvent({
          name: 'click-contact-your-dealer-expired-dm-banner-plan-details',
          properties: { apparatusId: this.expiredDealerManagedApparatus.apparatusId }
        })
        document.getElementById(
          'dealer-managed-sub-expired' + this.expiredDealerManagedApparatus.apparatusId
        ).style.display = 'block'
      }
    },
    closeDealerModal() {
      document.getElementById(
        'dealer-managed-sub-expired' + this.expiredDealerManagedApparatus.apparatusId
      ).style.display = 'none'
    }
  }
}
</script>

<style scoped>
.btn-contact-dealer {
  background-color: var(--carbon-900) !important;
}
.btn-contact-dealer:hover {
  background-color: var(--carbon-800) !important;
}
.btn-contact-dealer:pressed {
  background-color: var(--black) !important;
}
.btn-contact-support {
  border: 2px solid var(--black) !important;
  border-radius: 500px;
  color: var(--black) !important;
}
</style>
